(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-collection"] && !Shopify.designMode) return;
  try {
    
    component.collection();

    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            if (event.target.classList.contains('shopify-section--component-collection')) {
                component.collection(event.target);
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-custom-header"] && !Shopify.designMode) return;
  try {
    
        document.addEventListener('DOMContentLoaded', function () {
            const clearButtons = document.querySelectorAll('.custom-top-search__button--clear');
            clearButtons.forEach((button) => {
                button.addEventListener('click', function () {
                    const inputField = this.closest('.form__input').querySelector('input');
                    inputField.value = '';
                    inputField.focus();
                });
            });

            // 전역 브레드크럼 함수 정의
            window.updateBreadcrumbFromMenu = function (title, url, clickedElement) {
                let breadcrumbPath = [{ title: 'HOME', url: '/' }];

                if (title === 'HOME') {
                    breadcrumbPath = [{ title: 'HOME', url: '/' }];
                } else {
                    // 메뉴 구조에서 해당 제목의 링크 찾기
                    const allMenuLinks = document.querySelectorAll(
                        '.nav__depth1__link, .nav__depth2__link, .nav__depth3__link',
                    );
                    let foundLink = null;

                    // 정확히 일치하는 링크 찾기
                    allMenuLinks.forEach((link) => {
                        if (link.textContent.trim() === title) {
                            foundLink = link;
                        }
                    });

                    if (foundLink) {
                        const linkClasses = foundLink.className;

                        if (linkClasses.includes('nav__depth1__link')) {
                            // 1depth: SKINCARE 등
                            breadcrumbPath.push({ title: title, url: url });
                        } else if (linkClasses.includes('nav__depth2__link')) {
                            // 2depth: BY CATEGORY 등
                            const parentLi = foundLink.closest('li');
                            const parentNav = parentLi.closest('.nav__subwrap').previousElementSibling;
                            const parentDepth1Link = parentNav ? parentNav.querySelector('.nav__depth1__link') : null;

                            if (parentDepth1Link) {
                                breadcrumbPath.push({
                                    title: parentDepth1Link.textContent.trim(),
                                    url: parentDepth1Link.getAttribute('href'),
                                });
                            }
                            breadcrumbPath.push({ title: title, url: url });
                        } else if (linkClasses.includes('nav__depth3__link')) {
                            // 3depth: SERUM & ESSENCE 등
                            const parentLi = foundLink.closest('li');
                            const parentDepth2Li = parentLi.closest('ul').closest('li');
                            const parentDepth2Link = parentDepth2Li.querySelector('.nav__depth2__link');

                            const parentNav = foundLink.closest('.nav__subwrap').previousElementSibling;
                            const parentDepth1Link = parentNav ? parentNav.querySelector('.nav__depth1__link') : null;

                            if (parentDepth1Link) {
                                breadcrumbPath.push({
                                    title: parentDepth1Link.textContent.trim(),
                                    url: parentDepth1Link.getAttribute('href'),
                                });
                            }
                            if (parentDepth2Link) {
                                breadcrumbPath.push({
                                    title: parentDepth2Link.textContent.trim(),
                                    url: parentDepth2Link.getAttribute('href'),
                                });
                            }
                            breadcrumbPath.push({ title: title, url: url });
                        }
                    } else {
                        breadcrumbPath.push({ title: 'SKINCARE', url: '/collections/by-category' });
                        breadcrumbPath.push({ title: title, url: url });
                    }
                }

                // 최대 4개 레벨까지만 유지
                if (breadcrumbPath.length > 4) {
                    breadcrumbPath = breadcrumbPath.slice(-4);
                }

                sessionStorage.setItem('breadcrumbPath', JSON.stringify(breadcrumbPath));

                return breadcrumbPath;
            };

            function addToBreadcrumbPath(title, url) {
                const clickedLink = event.target.closest('a');
                return window.updateBreadcrumbFromMenu(title, url, clickedLink);
            }

            const logoLink = document.querySelector('.custom-header__logo');
            if (logoLink) {
                logoLink.addEventListener('click', function () {
                    addToBreadcrumbPath('HOME', '/');
                });
            }

            const menuLinks = document.querySelectorAll('.nav__depth1__link, .nav__depth2__link, .nav__depth3__link');
            menuLinks.forEach((link) => {
                link.addEventListener('click', function (e) {
                    if (this.classList.contains('nav__depth2__link--product')) {
                        sessionStorage.removeItem('breadcrumbPath');
                        return;
                    }

                    const href = this.getAttribute('href');
                    const title = this.textContent.trim();

                    // nav__depth1__link가 제품 URL인 경우 특별 처리
                    if (this.classList.contains('nav__depth1__link') && href && href.includes('/products/')) {
                        sessionStorage.removeItem('breadcrumbPath');
                        return;
                    }

                    // 특별 페이지로의 직접 이동인 경우 sessionStorage 클리어
                    if (href) {
                        const url = href.toLowerCase();
                        if (
                            url === '/pages/our-story' ||
                            url === '/collections/by-category' ||
                            url === '/collections/by-concern' ||
                            url.startsWith('/collections/by-category?') ||
                            url.startsWith('/collections/by-concern?')
                        ) {
                            sessionStorage.removeItem('breadcrumbPath');
                            return;
                        }
                    }

                    // 전역 event 객체 설정 (addToBreadcrumbPath에서 사용)
                    window.event = e;
                    const url = this.getAttribute('href');
                    addToBreadcrumbPath(title, url);
                });
            });
        });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-kv-banner"] && !Shopify.designMode) return;
  try {
        
    // 키비주얼 및 스크롤 버튼 초기화
    pageMain.kvBanner();
    pageMain.scrollToNextSection();
    
    // Shopify 에디터 모드에서 섹션 로드 시 재초기화
    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            if (event.target.classList.contains('shopify-section--main-kv-banner')) {
                pageMain.kvBanner(event.target);
                pageMain.scrollToNextSection(event.target);
            }
        });
    }
    
    // 슬라이드 변경 시 컨트롤러와 화살표 키의 data-col 속성 업데이트
    document.addEventListener('DOMContentLoaded', function() {
        const swiper = document.querySelector('.main_kv_swiper');
        if (swiper && typeof swiper.swiper !== 'undefined') {
            swiper.swiper.on('slideChange', function() {
                const activeSlide = swiper.querySelector('.swiper-slide-active');
                const controller = document.querySelector('.main_kv_controller');
                const arrowkey = document.querySelector('.main_kv_arrowkey');
                
                if (activeSlide && controller && arrowkey) {
                    const dataCol = activeSlide.getAttribute('data-col');
                    controller.setAttribute('data-col', dataCol);
                    arrowkey.setAttribute('data-col', dataCol);
                }
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-our-service-banner"] && !Shopify.designMode) return;
  try {
    
    pageMain.ourServiceBanner();
    
    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            if (event.target.classList.contains('shopify-section--main-our-service-banner')) {
                pageMain.ourServiceBanner(event.target);
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-category-navigator"] && !Shopify.designMode) return;
  try {
    
    let byConcernCollections = [];

    function modifyMainMenuLinks() {
        let byConcernMenu = null;

        const skincareMenu = Array.from(document.querySelectorAll('.header-menu-item, .menu-item')).find((item) => {
            return item.textContent.trim().includes('SKINCARE');
        });

        if (!skincareMenu) {
            return;
        }

        const submenuHeaders = Array.from(
            skincareMenu.querySelectorAll('.submenu-header, .dropdown-header, .submenu-title'),
        );
        for (const header of submenuHeaders) {
            if (header.textContent.trim().includes('BY CONCERN')) {
                byConcernMenu = header.closest('.submenu, .dropdown');

                break;
            }
        }

        const allSubmenus = skincareMenu.querySelectorAll('.submenu a, .dropdown a, .submenu-item a, .nav-link');

        if (allSubmenus.length === 0) {
            return;
        }

        allSubmenus.forEach((link) => {
            try {
                const originalUrl = link.getAttribute('href');
                if (!originalUrl) return;

                if (originalUrl.includes('/collections/by-concern?tab=')) {
                    return; // 이미 변환된 링크는 건너뛰기
                }

                if (!originalUrl.includes('/collections/')) {
                    return; // 컬렉션 링크가 아닌 경우 건너뛰기
                }

                const urlParts = originalUrl.split('/');
                let collectionHandle = '';

                if (urlParts.length > 0) {
                    const lastPart = urlParts[urlParts.length - 1];
                    collectionHandle = lastPart.split('?')[0];
                }

                if (!collectionHandle) return;

                // BY CONCERN 링크인지 명확하게 판단
                const isByConcernLink = byConcernMenu && byConcernMenu.contains(link);
                const isByConcernCollection = byConcernCollections.includes(collectionHandle);
                const isByConcernFinal = isByConcernLink || isByConcernCollection || collectionHandle === 'by-concern';

                link.setAttribute('data-collection-handle', collectionHandle);
                link.setAttribute('data-collection-url', originalUrl);

                if (!isByConcernFinal) {
                    // BY CONCERN이 아닌 링크는 원래 URL 유지

                    link.addEventListener('click', function (e) {
                        e.preventDefault();

                        window.history.pushState({ path: originalUrl }, '', originalUrl);

                        const tabChangeEvent = new CustomEvent('category-tab-changed', {
                            detail: {
                                collectionHandle: collectionHandle,
                                collectionUrl: originalUrl,
                                isByConcern: false,
                            },
                        });

                        document.dispatchEvent(tabChangeEvent);
                    });

                    return; // 이 링크 처리 완료
                }

                // BY CONCERN 링크인 경우 URL 형식 변환

                let newUrl;
                const baseUrl = '/collections/by-concern';

                if (collectionHandle === 'by-concern') {
                    newUrl = baseUrl;
                } else {
                    newUrl = `${baseUrl}?tab=${collectionHandle}`;
                }

                link.setAttribute('href', newUrl);
                link.setAttribute('data-is-by-concern', 'true');

                link.addEventListener('click', function (e) {
                    e.preventDefault();

                    let targetUrl;
                    if (collectionHandle === 'by-concern') {
                        targetUrl = baseUrl;
                    } else {
                        targetUrl = `${baseUrl}?tab=${collectionHandle}`;
                    }

                    window.history.pushState({ path: targetUrl }, '', targetUrl);

                    const tabChangeEvent = new CustomEvent('category-tab-changed', {
                        detail: {
                            collectionHandle: collectionHandle,
                            collectionUrl: originalUrl,
                            isByConcern: true,
                        },
                    });

                    document.dispatchEvent(tabChangeEvent);
                });
            } catch (error) {}
        });
    }

    function initializeTabs() {
        // 현재 컬렉션 경로 확인
        const currentPathParts = window.location.pathname.split('/');
        const currentCollection = currentPathParts[currentPathParts.length - 1]; // 현재 URL의 마지막 부분

        // URL 파라미터에서 탭 값 가져오기
        const urlParams = new URLSearchParams(window.location.search);
        const currentTab = urlParams.get('tab');

        // 모든 탭 항목에서 active 클래스 제거
        document.querySelectorAll('.plp-category-navigator__item').forEach((item) => {
            item.classList.remove('active');
        });

        // 활성화할 탭 요소 결정
        let activeTab = null;

        // URL에 탭 파라미터가 있는 경우 (by-concern 페이지)
        if (currentTab) {
            // 1. data-collection-handle로 먼저 찾기
            const matchingLinks = document.querySelectorAll(
                `.category-tab-link[data-collection-handle="${currentTab}"]`,
            );
            if (matchingLinks.length >= 2) {
                activeTab = document.querySelector(`.plp-category-navigator__item[data-tab-handle="${currentTab}"]`);
                if (activeTab) {
                }
            }

            // 2. 핸들이 비어있고 URL에 tab 파라미터가 있는 경우를 처리
            if (!activeTab) {
                // data-collection-url 속성에서 tab 파라미터를 확인
                document.querySelectorAll('.category-tab-link').forEach((link) => {
                    const url = link.getAttribute('data-collection-url');
                    if (url && url.includes(`tab=${currentTab}`)) {
                        activeTab = link.closest('.plp-category-navigator__item');

                        return;
                    }
                });
            }
        }

        // 방법 2: 현재 URL 경로의 컬렉션 핸들로 찾기
        if (!activeTab && currentCollection) {
            // 모든 탭 링크를 확인하여 이름이 일치하는 탭이 2개 이상인 경우만 active 클래스 추가
            const matchingLinks = document.querySelectorAll(
                `.category-tab-link[data-collection-handle="${currentCollection}"]`,
            );
            if (matchingLinks.length >= 2) {
                // data-tab-handle 속성으로 먼저 찾기
                activeTab = document.querySelector(
                    `.plp-category-navigator__item[data-tab-handle="${currentCollection}"]`,
                );
                if (activeTab) {
                } else {
                    // collection-handle 속성으로 찾기 시도
                    const activeTabLink = document.querySelector(
                        `.category-tab-link[data-collection-handle="${currentCollection}"]`,
                    );
                    if (activeTabLink) {
                        activeTab = activeTabLink.closest('.plp-category-navigator__item');
                    }
                }
            }
        }

        // 찾은 탭에 active 클래스 추가
        if (activeTab) {
            activeTab.classList.add('active');
            component.plpCategoryNavigator();
        } else {
        }

        // 탭 컨테이너에 이벤트 위임 설정 (더 안정적인 방식)
        const tabContainer = document.querySelector('.plp-category-navigator__list');
        if (tabContainer) {
            // 기존 이벤트 리스너 제거
            tabContainer.removeEventListener('click', tabContainerClickHandler);
            // 새 이벤트 리스너 추가
            tabContainer.addEventListener('click', tabContainerClickHandler);
        } else {
            // 대체 방법: 개별 링크에 이벤트 리스너 추가
            document.querySelectorAll('.category-tab-link').forEach((link) => {
                if (link.hasAttribute('data-tab-initialized')) {
                    return; // 이미 초기화된 링크는 건너뛰기
                }

                link.setAttribute('data-tab-initialized', 'true');
                // 기존 이벤트 리스너 제거 후 새로 추가
                link.removeEventListener('click', handleTabClick);
                link.addEventListener('click', handleTabClick);
            });
        }
    }

    // 탭 컨테이너 클릭 핸들러 (이벤트 위임)
    function tabContainerClickHandler(e) {
        // 클릭된 요소가 탭 링크인지 확인
        const link = e.target.closest('.category-tab-link');
        if (!link) return; // 탭 링크가 아니면 무시

        e.preventDefault();

        updateBreadcrumbPath(link);

        // 클릭된 탭 아이템 찾기
        const tabItem = link.closest('.plp-category-navigator__item');

        // 클릭된 링크의 collection-handle 값 가져오기
        let collectionHandle = link.getAttribute('data-collection-handle');
        const collectionUrl = link.getAttribute('data-collection-url');

        // handle이 비어 있고 URL에 tab 파라미터가 있는 경우 탭 값 추출
        if ((!collectionHandle || collectionHandle.trim() === '') && collectionUrl && collectionUrl.includes('?tab=')) {
            const tabMatch = collectionUrl.match(/\?tab=([^&]+)/);
            if (tabMatch && tabMatch[1]) {
                collectionHandle = tabMatch[1];
            }
        }

        // 동일한 collection-handle을 가진 링크가 2개 이상인지 확인
        let matchingLinks = [];
        if (collectionHandle && collectionHandle.trim() !== '') {
            matchingLinks = document.querySelectorAll(
                `.category-tab-link[data-collection-handle="${collectionHandle}"]`,
            );
        }

        // URL의 tab 파라미터가 동일한 링크도 찾기
        if (collectionUrl && collectionUrl.includes('?tab=')) {
            const tabMatch = collectionUrl.match(/\?tab=([^&]+)/);
            if (tabMatch && tabMatch[1]) {
                const tabValue = tabMatch[1];
                document.querySelectorAll('.category-tab-link').forEach((otherLink) => {
                    const otherUrl = otherLink.getAttribute('data-collection-url');
                    if (otherUrl && otherUrl.includes(`tab=${tabValue}`)) {
                        matchingLinks = Array.from(new Set([...matchingLinks, otherLink]));
                    }
                });
            }
        }

        // 모든 탭 항목에서 active 클래스 제거
        document.querySelectorAll('.plp-category-navigator__item').forEach((item) => {
            item.classList.remove('active');
        });

        // 동일한 핸들 또는 URL의 tab 파라미터가 있는 경우 active 클래스 추가
        if (matchingLinks.length >= 1 && tabItem) {
            tabItem.classList.add('active');
        }

        // const isMobile = window.innerWidth <= 767;
        // if (isMobile) {
        //     console.log('scroll');
        //     setTimeout(() => {
        //         const bannerSection = document.querySelector('.component-plp-banner');
        //         const categoryNavigator = document.querySelector('.plp-category-navigator');

        //         if (bannerSection && categoryNavigator) {
        //             const bannerRect = bannerSection.getBoundingClientRect();
        //             const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        //             const navigatorHeight = categoryNavigator.offsetHeight || 52;
        //             const targetY = bannerRect.bottom + scrollTop - navigatorHeight;

        //             window.scrollTo({
        //                 top: targetY,
        //                 behavior: 'smooth',
        //             });
        //         }
        //     }, 300);
        // }

        component.plpCategoryNavigator();

        // 핸들러 함수 호출 - 이벤트 객체 전달
        handleTabClick.call(link, e);
    }

    function handleTabClick(e) {
        e.preventDefault();

        // DOM 요소 참조를 명확히 저장
        const clickedLink = this;
        const clickedItem = clickedLink.closest('.plp-category-navigator__item');

        // DOM 요소 디버깅

        // 핸들값 추출 및 검증
        let collectionHandle = clickedLink.getAttribute('data-collection-handle');
        const collectionUrl = clickedLink.getAttribute('data-collection-url') || clickedLink.getAttribute('href');
        const isByConcern = clickedLink.getAttribute('data-is-by-concern') === 'true';

        // URL에서 탭 값 추출 시도
        if (collectionUrl && collectionUrl.includes('?tab=')) {
            const tabMatch = collectionUrl.match(/\?tab=([^&]+)/);
            if (tabMatch && tabMatch[1]) {
                const tabValue = tabMatch[1];

                // data-collection-handle이 없거나 빈 값이면 탭 값으로 설정
                if (!collectionHandle || collectionHandle.trim() === '') {
                    collectionHandle = tabValue;
                }
            }
        }

        // URL에서 컬렉션 핸들 추출 시도
        if ((!collectionHandle || collectionHandle.trim() === '') && collectionUrl) {
            const urlParts = collectionUrl.split('/');
            const lastPart = urlParts[urlParts.length - 1].split('?')[0];

            if (lastPart && lastPart.trim() !== '') {
                collectionHandle = lastPart;
            }
        }

        // 빈 값 검사 - 여전히 빈 값이면 경고 출력
        if (!collectionHandle || collectionHandle.trim() === '') {
            return;
        }

        // 모든 탭 항목에서 active 클래스 제거
        document.querySelectorAll('.plp-category-navigator__item').forEach((item) => {
            item.classList.remove('active');
        });

        // 클릭한 아이템에 active 클래스 추가
        if (clickedItem) {
            clickedItem.classList.add('active');
        }

        // BY CONCERN 여부 확인 (애니메이션 처리 위해)
        const isByConcernElement = clickedItem && clickedItem.getAttribute('data-is-by-concern') === 'true';
        const isByConcernCollection = byConcernCollections.includes(collectionHandle);

        // 최종 BY CONCERN 여부
        const shouldAnimate = isByConcern || isByConcernElement || isByConcernCollection;

        // 모든 경우에 탭 변경 처리
        performTabChange(collectionHandle, collectionUrl, clickedItem, shouldAnimate);
    }

    function performTabChange(collectionHandle, collectionUrl, clickedItem, shouldAnimate) {
        // collectionHandle 최종 검증
        if (!collectionHandle || collectionHandle.trim() === '') {
            return;
        }

        // 모든 탭 항목에서 active 클래스 제거
        document.querySelectorAll('.plp-category-navigator__item').forEach((item) => {
            item.classList.remove('active');
        });

        // 클릭한 요소에 active 클래스 추가
        if (clickedItem) {
            clickedItem.classList.add('active');
        } else {
            const tabItem = document.querySelector(`[data-tab-handle="${collectionHandle}"]`);
            if (tabItem) {
                tabItem.classList.add('active');
            }
        }

        // URL 설정
        let targetUrl;

        // BY CONCERN 핸들인지 명확하게 확인 (byConcernCollections 배열 재확인)
        const isByConcernHandle = collectionHandle === 'by-concern' || byConcernCollections.includes(collectionHandle);

        // 클릭한 요소가 BY CONCERN으로 명시되었는지 확인
        const isByConcernElementAttribute = clickedItem && clickedItem.getAttribute('data-is-by-concern') === 'true';

        // 최종 BY CONCERN 여부 판단
        const isByConcernFinal = isByConcernHandle || isByConcernElementAttribute || shouldAnimate;

        if (isByConcernFinal) {
            // BY CONCERN 컬렉션인 경우 /collections/by-concern?tab= 형식 사용
            const baseUrl = '/collections/by-concern';
            if (collectionHandle === 'by-concern') {
                targetUrl = baseUrl;
            } else {
                targetUrl = `${baseUrl}?tab=${collectionHandle}`;
            }
        } else {
            // BY CONCERN이 아닌 경우 원래 URL 사용
            if (collectionUrl && collectionUrl !== 'javascript:void(0);') {
                targetUrl = collectionUrl;
            } else {
                targetUrl = `/collections/${collectionHandle}`;
            }
        }

        // URL 변경
        window.history.pushState({ path: targetUrl }, '', targetUrl);

        // 이벤트 발생
        const tabChangeEvent = new CustomEvent('category-tab-changed', {
            detail: {
                collectionHandle: collectionHandle,
                collectionUrl: collectionUrl,
                isByConcern: isByConcernFinal, // 애니메이션 필요 여부 전달
            },
        });

        document.dispatchEvent(tabChangeEvent);
    }

    function updateBreadcrumbPath(link) {
        const tabTitle = link.textContent.trim();
        const collectionHandle = link.getAttribute('data-collection-handle');
        const collectionUrl = link.getAttribute('data-collection-url');
        const isByConcern = link.getAttribute('data-is-by-concern') === 'true';
        const currentUrl = window.location.pathname;

        if (currentUrl === '/collections/by-category' || currentUrl === '/collections/by-concern') {
            let breadcrumbPath = [{ title: 'HOME', url: '/' }];

            // SKINCARE 추가
            breadcrumbPath.push({ title: 'SKINCARE', url: '/collections/by-category' });

            if (isByConcern) {
                // BY CONCERN 경로: HOME > SKINCARE > BY CONCERN > [탭제목]
                breadcrumbPath.push({ title: 'BY CONCERN', url: '/collections/by-concern' });
            } else {
                // BY CATEGORY 경로: HOME > SKINCARE > BY CATEGORY > [탭제목]
                breadcrumbPath.push({ title: 'BY CATEGORY', url: '/collections/by-category' });
            }

            // 탭 제목 추가
            if (tabTitle && (collectionUrl || collectionHandle)) {
                const url = collectionUrl || `/collections/${collectionHandle}`;
                breadcrumbPath.push({ title: tabTitle, url: url });
            }

            sessionStorage.setItem('breadcrumbPath', JSON.stringify(breadcrumbPath));
            return;
        }

        // 다른 페이지의 경우 기존 로직 사용
        if (window.updateBreadcrumbFromMenu) {
            const finalUrl = collectionUrl || `/collections/${collectionHandle}`;
            window.updateBreadcrumbFromMenu(tabTitle, finalUrl, link);
        } else {
            // 기본 폴백 로직
            let breadcrumbPath = [{ title: 'HOME', url: '/' }];

            const mainMenuLinks = document.querySelectorAll(
                '.nav__depth1__link, .nav__depth2__link, .nav__depth3__link',
            );
            let foundMenuPath = null;

            mainMenuLinks.forEach((menuLink) => {
                if (menuLink.textContent.trim() === tabTitle) {
                    const linkClasses = menuLink.className;

                    if (linkClasses.includes('nav__depth3__link')) {
                        const parentLi = menuLink.closest('li').closest('li');
                        const parentDepth1 = parentLi.closest('.nav__depth1').querySelector('.nav__depth1__link');
                        const parentDepth2 = parentLi.querySelector('.nav__depth2__link');

                        foundMenuPath = [];
                        if (parentDepth1) {
                            foundMenuPath.push({
                                title: parentDepth1.textContent.trim(),
                                url: parentDepth1.getAttribute('href'),
                            });
                        }
                        if (parentDepth2) {
                            foundMenuPath.push({
                                title: parentDepth2.textContent.trim(),
                                url: parentDepth2.getAttribute('href'),
                            });
                        }
                        foundMenuPath.push({
                            title: tabTitle,
                            url: collectionUrl || `/collections/${collectionHandle}`,
                        });
                    } else if (linkClasses.includes('nav__depth2__link')) {
                        const parentDepth1 = menuLink
                            .closest('li')
                            .closest('.nav__depth1')
                            .querySelector('.nav__depth1__link');

                        foundMenuPath = [];
                        if (parentDepth1) {
                            foundMenuPath.push({
                                title: parentDepth1.textContent.trim(),
                                url: parentDepth1.getAttribute('href'),
                            });
                        }
                        foundMenuPath.push({
                            title: tabTitle,
                            url: collectionUrl || `/collections/${collectionHandle}`,
                        });
                    }
                }
            });

            if (foundMenuPath && foundMenuPath.length > 0) {
                breadcrumbPath = breadcrumbPath.concat(foundMenuPath);
            } else {
                breadcrumbPath.push({ title: 'SKINCARE', url: '/collections/by-category' });
                if (tabTitle && (collectionUrl || collectionHandle)) {
                    const url = collectionUrl || `/collections/${collectionHandle}`;
                    breadcrumbPath.push({ title: tabTitle, url: url });
                }
            }

            sessionStorage.setItem('breadcrumbPath', JSON.stringify(breadcrumbPath));
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        try {
            byConcernCollections = [];

            const skincareMenu = Array.from(document.querySelectorAll('.header-menu-item, .menu-item')).find((item) => {
                return item.textContent.trim().includes('SKINCARE');
            });

            if (skincareMenu) {
                const byConcernHeader = Array.from(
                    skincareMenu.querySelectorAll('.submenu-header, .dropdown-header, .submenu-title'),
                ).find((header) => {
                    return header.textContent.trim().includes('BY CONCERN');
                });

                if (byConcernHeader) {
                    const byConcernMenu = byConcernHeader.closest('.submenu, .dropdown');
                    if (byConcernMenu) {
                        const byConcernLinks = byConcernMenu.querySelectorAll('a');
                        byConcernLinks.forEach((link) => {
                            const href = link.getAttribute('href');
                            if (href && href.includes('/collections/')) {
                                const urlParts = href.split('/');
                                const handle = urlParts[urlParts.length - 1].split('?')[0];
                                if (handle && !byConcernCollections.includes(handle)) {
                                    byConcernCollections.push(handle);
                                }
                            }
                        });
                    }
                }
            }

            document.querySelectorAll('.category-tab-link[data-is-by-concern="true"]').forEach((link) => {
                const handle = link.getAttribute('data-collection-handle');
                if (handle && !byConcernCollections.includes(handle)) {
                    byConcernCollections.push(handle);
                }
            });

            if (!byConcernCollections.includes('by-concern')) {
                byConcernCollections.push('by-concern');
            }

            modifyMainMenuLinks();
            initializeTabs();
        } catch (error) {}
    });

  } catch(e) { console.error(e); }
})();
})();
